// eslint-disable-next-line import/prefer-default-export
export const toggleNavMenuLabels = (payload) => ({
  type: 'toggleNavMenuLabels',
  payload,
});
